import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom-v5-compat';

import YourClaimsPageV2 from './containers/YourClaimsPageV2';
import YourClaimLetters from './containers/YourClaimLetters';
import ClaimPage from './containers/ClaimPage';
import ClaimStatusPage from './containers/ClaimStatusPage';
import FilesPage from './containers/FilesPage';

import DocumentRequestPage from './containers/DocumentRequestPage';
import ClaimEstimationPage from './containers/ClaimEstimationPage';
import AppealsV2StatusPage from './containers/AppealsV2StatusPage';
import AppealsV2DetailPage from './containers/AppealsV2DetailPage';
import AppealInfo from './containers/AppealInfo';
import SupplementalClaimFilesPage from './containers/SupplementalClaimFilesPage';
import ClaimsStatusApp from './containers/ClaimsStatusApp';
import IntentToFilePage from './containers/IntentToFilePage';
import OverviewPage from './containers/OverviewPage';
import Standard5103NoticePage from './containers/Standard5103NoticePage';
import DocumentRedirectPage from './containers/DocumentRedirectPage';
import FilesWeCouldntReceive from './components/FilesWeCouldntReceive';
import AppealSubpathRedirect from './components/appeals-v2/AppealSubpathRedirect';
import ClaimIndexRoute from './components/claim-tabs/ClaimIndexRoute';
import ClaimSubpathRedirect from './components/claim-tabs/ClaimSubpathRedirect';
import ClaimTabRoute from './components/claim-tabs/ClaimTabRoute';

import { INTENT_TO_FILE_PATH } from './constants';

const routes = (
  <Routes>
    <Route path="/" element={<ClaimsStatusApp />}>
      <Route index element={<Navigate to="your-claims" replace />} />
      <Route path="appeals" element={<Navigate to="/your-claims" replace />} />
      <Route path="appeals/:id" element={<AppealInfo />}>
        <Route index element={<Navigate to="status" replace />} />
        <Route path="detail" element={<AppealsV2DetailPage />} />
        <Route path="status" element={<AppealsV2StatusPage />} />
        <Route path="files" element={<SupplementalClaimFilesPage />} />
      </Route>
      {/* Sibling, not a nested * child, so the redirect stays standalone and immediate instead of gating on AppealInfo's load/availability + Outlet. */}
      <Route path="appeals/:id/*" element={<AppealSubpathRedirect />} />
      <Route path="your-claims" element={<YourClaimsPageV2 />} />
      <Route
        path="your-claims/files-we-couldnt-receive"
        element={<FilesWeCouldntReceive />}
      />
      <Route path="your-claims/:id" element={<ClaimPage />}>
        <Route index element={<ClaimIndexRoute />} />
        <Route
          path="5103-evidence-notice"
          element={<Standard5103NoticePage />}
        />
        <Route path="claim-estimate" element={<ClaimEstimationPage />} />
        <Route
          path="document-request/:trackedItemId"
          element={<DocumentRedirectPage />}
        />
        <Route
          path="needed-from-you"
          element={<ClaimTabRoute tab="status" />}
        />
        <Route
          path="needed-from-you/:trackedItemId"
          element={<DocumentRequestPage />}
        />
        <Route
          path="needed-from-others"
          element={<ClaimTabRoute tab="status" />}
        />
        <Route
          path="needed-from-others/:trackedItemId"
          element={<DocumentRequestPage />}
        />
        <Route
          path="files"
          element={<ClaimTabRoute tab="files" element={<FilesPage />} />}
        />
        <Route
          path="overview"
          element={<ClaimTabRoute tab="overview" element={<OverviewPage />} />}
        />
        <Route
          path="status"
          element={<ClaimTabRoute tab="status" element={<ClaimStatusPage />} />}
        />
      </Route>
      {/* Sibling, not a nested * child, so the redirect stays standalone and immediate instead of gating on ClaimPage's fetch + Outlet. */}
      <Route path="your-claims/:id/*" element={<ClaimSubpathRedirect />} />
      <Route path={INTENT_TO_FILE_PATH} element={<IntentToFilePage />} />
      <Route path="your-claim-letters" element={<YourClaimLetters />} />
      <Route
        path="your-claim-letters/link"
        element={<Navigate to="/your-claim-letters" replace />}
      />
    </Route>
  </Routes>
);

export default routes;
